import { createSelector } from 'reselect'
// import { List } from 'immutable'

const masterDataSelector = state => state.get('masterData')

export const getIsFetching = createSelector(
  masterDataSelector,
  masterDataImmutable => {
    const masterData = masterDataImmutable.toJS()
    return masterData.masterDataGet.isFetching
  }
)
export const getGetMasterData = createSelector(
  masterDataSelector,
  masterDataImmutable => {
    const masterData = masterDataImmutable.toJS()
    return masterData.masterDataGet
  }
)
export const redirectMaster = createSelector(
  masterDataSelector,
  masterDataImmutable => {
    const masterData = masterDataImmutable.toJS()
    return ({
      redirect: (masterData.masterDataGet.redirect),
      isAuthenticated: (masterData.masterDataGet.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/master-data/master-data-selector.js